export default "__VITE_ASSET__CHTdmYP$__"